/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import FormTable from './FormTable.react';
import React from 'react';

let CertsTable = ({ credentials, onDelete }) => {


  const tableData = [{
    title: credentials.project_id,
    onDelete: onDelete.bind(null),
    color: 'green',
    notes: [
      {
        key: 'Private key id',
        value: credentials.private_key_id,
        strong: true,
      },
      {
        key: 'Client id',
        value: credentials.client_id,
        strong: true,
      },
    ]
  }];


  return <FormTable items={tableData} />
};

export default CertsTable;
